import React, { useState, useEffect } from "react";
import {
  Grid,
  Card,
  CardContent,
  CardHeader,
  Typography,
  Stack,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers-pro";
import ContentBox from "../../../actprep-ui/components/ContentBox";
import MasterSheetV2 from "../../../components/MasterSheetV2";
import dayjs from "dayjs";
import layout from "../../../actprep-ui/constants/layout";
import { useSearchParams } from "react-router-dom";

export default function MasterSheetV2Page() {
  const [searchParams, setSearchParams] = useSearchParams();

  // Get start date from URL params or default to start of current week
  const startDateParam = searchParams.get("start_date");
  const [startDate, setStartDate] = useState(
    startDateParam ? dayjs(startDateParam) : dayjs().startOf("week")
  );

  // For now, we'll use a placeholder rootRaId - this should be configurable
  // In a real implementation, you might want to fetch available root role assignments
  const rootRaId = null;

  const handleStartDateChange = (newDate) => {
    setStartDate(newDate);

    // Update URL search params
    const newSearchParams = new URLSearchParams(searchParams);
    if (newDate) {
      newSearchParams.set("start_date", newDate.format("YYYY-MM-DD"));
    } else {
      newSearchParams.delete("start_date");
    }
    setSearchParams(newSearchParams);
  };

  // Update startDate when URL params change (e.g., browser back/forward)
  useEffect(() => {
    const startDateParam = searchParams.get("start_date");
    if (startDateParam) {
      const urlDate = dayjs(startDateParam);
      if (!urlDate.isSame(startDate, "day")) {
        setStartDate(urlDate);
      }
    }
  }, [searchParams, startDate]);

  return (
    <Grid container spacing={2} sx={{ mt: `${layout.navBarHeight + 1}rem` }}>
      <Grid size={12}>
        <ContentBox>
          <Card>
            <CardHeader
              title={
                <Stack direction="row" spacing={2} alignItems="center">
                  <Typography variant="h5" fontWeight="bold">
                    Master Sheet V2
                  </Typography>
                </Stack>
              }
              subheader="Hierarchical view of coaching performance data"
              action={
                <Stack direction="row" spacing={1} alignItems="center">
                  <DatePicker
                    label="Week Start Date"
                    value={startDate}
                    onChange={handleStartDateChange}
                    slotProps={{
                      textField: {
                        size: "small",
                      },
                    }}
                  />
                </Stack>
              }
            />
            <CardContent>
              <MasterSheetV2
                rootRaId={rootRaId}
                startDate={startDate.format("YYYY-MM-DD")}
                pageSizeOptions={[25, 50, 100]}
                defaultExpandAll={false}
              />
            </CardContent>
          </Card>
        </ContentBox>
      </Grid>
    </Grid>
  );
}
